import Joi from 'joi'
import AppError from '../../shared/errors/appError.js'
import { ERROR_CODES } from '../../shared/constants/errors.js'

class Validator {
  static require(name, value, expectedType) {
    const schema = buildSchema(expectedType)
    const { error } = schema.validate(value)

    if (error) {
      const reason = value === undefined ? 'REQUIRED' : 'INVALID_TYPE'
      throwValidationError(name, value, reason, { joi: error.message })
    }
  }

  static requireMatch(name, value, regex) {
    if (typeof value !== 'string') {
      throwValidationError(name, value, 'NOT_A_STRING')
    }
    if (!regex.test(value)) {
      throwValidationError(name, value, 'REGEX_MISMATCH')
    }
  }

  static requireObject(name, value) {
    if (typeof value !== 'object' || value === null || Array.isArray(value)) {
      throwValidationError(name, value, 'NOT_AN_OBJECT')
    }
  }

  static requireOneOf(name, value, allowedValues) {
    if (!Array.isArray(allowedValues)) {
      throw new AppError(
        `Allowed values for "${name}" must be an array`,
        400,
        ERROR_CODES.VALIDATION_ERROR,
        { param: name },
      )
    }

    if (!allowedValues.includes(value)) {
      throwValidationError(name, value, 'VALUE_NOT_ALLOWED', {
        allowedValues,
      })
    }
  }
}

function buildSchema(expectedType) {
  switch (expectedType.toLowerCase()) {
    case 'string':
      return Joi.string().required()
    case 'number':
      return Joi.number().required()
    case 'boolean':
      return Joi.boolean().required()
    case 'array':
      return Joi.array().required()
    case 'object':
      return Joi.object().required()
    case 'function':
      return Joi.func().required()
    case 'class':
      return Joi.function()
        .required()
        .custom((value, helpers) => {
          if (
            typeof value !== 'function' ||
            !/^class\s/.test(value.toString())
          ) {
            return helpers.error('any.invalid')
          }
          return value
        }, 'class check')
    default:
      throw new AppError(
        `Unknown expected type: ${expectedType}`,
        999,
        ERROR_CODES.INTERNAL_ERROR,
        { expectedType },
      )
  }
}

function throwValidationError(name, receivedValue, reason, extra = {}) {
  throw new AppError(
    `Erreur de validation pour le paramètre "${name}".`,
    400,
    ERROR_CODES.VALIDATION_ERROR,
    {
      param: name,
      reason,
      ...extra,
      received: receivedValue,
    },
  )
}

export default Validator
